import AccessGroupAutocomplete from './AccessGroupAutocomplete';

export default AccessGroupAutocomplete;
